<template>
  <div id="vue-app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style src="normalize.css"></style>



// WEBPACK FOOTER //
// src/App.vue